<template>
  <div class="modal fade" :class="show ? 'show' : 'hide'" style="display: block; background-color: rgba(0,0,0,0.3)">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="search-modal-header">
          <font-awesome-icon class="warning-icon" icon="exclamation-triangle"/>
          <span class="search-modal-title">Are you sure you want to log out?</span>
        </div>
        <div class="search-modal-body">
          <span> </span>
        </div>
        <div class="search-modal-footer">
          <button class="btn light-button" @click="closePopup" type="button">No</button>
          <button class="btn dark-button" type="button" @click="logout">Yes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import studiesActions from '../../store/modules/studies/actionTypes'

export default {
  name: 'LogoutPopup',
  data () {
    return {
      show: false,
      nextLocation: null
    }
  },
  methods: {
    ...mapActions({
      updateStoreFilters: studiesActions.SET_OR_CLEAR_SEARCH_FILTERS,
      updateCICSFilters: studiesActions.RESET_CICS_FILTERS
    }),
    showPopup () {
      this.show = true
    },
    closePopup () {
      this.show = false
    },
    logout () {
      this.$auth.logout()
      this.$router.push({ name: 'login' })
      this.closePopup()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.hide {
  height: 0;
}

.show {
  height: 100%;
}

.modal-dialog {
  margin-top: 80px;
}

.modal-content {
  width: 604px;
  height: 215px;
  background-color: #FFFAF3 !important;
  border: 1px solid #CCBEA0 !important;
  border-radius: 4px;

  .search-modal-header {
    display: flex;
    justify-content: start;
    height: 42px;
    width: 100%;
    margin-top: 33px;
    align-items: flex-end;
    padding-left: 42px;

    .search-modal-title {
      color: #7A4D05;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 18px;
      font-weight: 900;
      line-height: 23px;
      letter-spacing: 0;
      margin-left: 41px;
    }

    .close {
      position: absolute;
      top: 11px;
      right: 11px;
      line-height: 0.8125rem;
    }

    .warning-icon {
      font-size: 40px;
      color: $charcoal;
    }
  }

  .search-modal-body {
    color: #7A4D05CC;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0;
    margin-top: 19px;
    margin-left: 129px;
  }

  .search-modal-footer {
    margin-top: 38px;
    display: flex;
    justify-content: flex-end;
    margin-right: 47px;

    .btn {
      width: 73px;
      height: 40px;
      border-radius: 6px;
      color: white;
      font-family: 'Source Sans Pro', sans-serif;
      font-size: 11px;
      line-height: 20px;
      letter-spacing: 0;
      font-weight: 900;
    }

    .light-button {
      background-color: $silver;
      margin-right: 32px;
      transition: background-color 0.2s linear;

      &:hover {
        background-color: $pewter;
      }
    }

    .dark-button {
      background-color: $pewter;
      transition: background-color 0.2s linear;

      &:hover {
        background-color: $charcoal;
      }
    }
  }
}

</style>
